import { render, staticRenderFns } from "./double.vue?vue&type=template&id=58377dea&scoped=true&"
import script from "./double.vue?vue&type=script&lang=js&"
export * from "./double.vue?vue&type=script&lang=js&"
import style0 from "./double.vue?vue&type=style&index=0&id=58377dea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58377dea",
  null
  
)

export default component.exports